import * as Yup from "yup";
import checkout from "./Form";

const {
  formField: {
    // datas
    name,
    CNPJ,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // datas
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [CNPJ.name]: Yup.string()
      .test("cnpj", "CNPJ inválido", function (item) {
        if (!item) return false;

        // Aceita receber o valor como string, número ou array com todos os dígitos
        const isString = typeof item === "string";
        const validTypes =
          isString || Number.isInteger(item) || Array.isArray(item);

        // Elimina valor em formato inválido
        if (!validTypes) return false;

        // Filtro inicial para entradas do tipo string
        if (isString) {
          // Limita ao máximo de 18 caracteres, para CNPJ formatado
          if (item.length > 18) return false;

          // Teste Regex para veificar se é uma string apenas dígitos válida
          const digitsOnly = /^\d{14}$/.test(item);
          // Teste Regex para verificar se é uma string formatada válida
          const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(item);

          // Se o formato é válido, usa um truque para seguir o fluxo da validação
          if (digitsOnly || validFormat) return true;
          // Se não, retorna inválido
          else return false;
        }

        // Guarda um array com todos os dígitos do valor
        const match = item.toString().match(/\d/g);
        const numbers = Array.isArray(match) ? match.map(Number) : [];

        // Valida a quantidade de dígitos
        if (numbers.length !== 14) return false;

        // Elimina inválidos com todos os dígitos iguais
        const items = [...new Set(numbers)];
        if (items.length === 1) return false;

        // Cálculo validador
        const calc = (x) => {
          const slice = numbers.slice(0, x);
          let factor = x - 7;
          let sum = 0;

          for (let i = x; i >= 1; i--) {
            const n = slice[x - i];
            sum += n * factor--;
            if (factor < 2) factor = 9;
          }

          const result = 11 - (sum % 11);

          return result > 9 ? 0 : result;
        };

        // Separa os 2 últimos dígitos de verificadores
        const digits = numbers.slice(12);

        // Valida 1o. dígito verificador
        const digit0 = calc(12);
        if (digit0 !== digits[0]) return false;

        // Valida 2o. dígito verificador
        const digit1 = calc(13);
        return digit1 === digits[1];
      })
      .required(CNPJ.errorMsg)
      .min(18, CNPJ.invalidMsg),
  }),
];
